if (!customElements.get('fixed-nav-bar')) {
  class FixedNavBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      window.addEventListener('load', () => {
        const target = document.querySelector(`:target`)?.getAttribute('id');

        if (!target) return;

        this.querySelector(`a[href="#${target}"]`).classList.add('active');
      });

      this.querySelectorAll('a').forEach((link) =>
        link.addEventListener('click', this.onLinkClick.bind(this)),
      );

      this.querySelector('.js-scroll-top')?.addEventListener(
        'click',
        this.onScrollTopClick,
      );
    }

    onLinkClick(event) {
      this.querySelectorAll('a').forEach((link) =>
        link.classList.toggle('active', link === event.target),
      );
    }

    onScrollTopClick() {
      document.documentElement.scrollTop = 0;
    }
  }
  customElements.define('fixed-nav-bar', FixedNavBar);
}
